import React from 'react';
import { Box, Card, CardContent } from '@deere/fuel-react';
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import StepLabel from "@material-ui/core/StepLabel";
import { ColorLibConnector, useStyles } from "../shared/styles/Stepper";
import { ColorLibStepIcon } from "../shared/ColorStepIcon";

export const StepperComponent = ({ steps, disable, activeStep, onClick, disableStepNum }) => {
    const classes = useStyles();
    const handleStep = (step) => () => {
        onClick(step);
    };
    return (
        <Box mt={2} mr={6}>
            <Card>
                <CardContent>
                    <div className={classes.root}>
                        {disable && (<Stepper alternativeLabel activeStep={activeStep}
                            connector={<ColorLibConnector />}
                            style={{ padding: 0 }}>
                            {steps.map((label, index) => (
                                <Step key={label} disabled={disable}>
                                    <StepButton style={{ outline: 'none' }}
                                        disabled={index === disableStepNum ? false : disable}
                                        onClick={handleStep(index)}>
                                        <StepLabel StepIconComponent={ColorLibStepIcon}
                                            disabled={index === disableStepNum ? false : disable}
                                            StepIconProps={{ disabled: index === disableStepNum ? false : disable }}>{label}</StepLabel>
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper>)}
                        {!disable && (
                            <Stepper alternativeLabel activeStep={activeStep}
                                connector={<ColorLibConnector />}
                                style={{ padding: 0 }}>
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepButton style={{ outline: 'none' }}
                                            onClick={handleStep(index)}>
                                            <StepLabel
                                                StepIconComponent={ColorLibStepIcon}>{label}</StepLabel>
                                        </StepButton>
                                    </Step>
                                ))}
                            </Stepper>
                        )}
                    </div>
                </CardContent>
            </Card>
        </Box>
    )
}